import { render, staticRenderFns } from "./RadioGroupWithValidation.vue?vue&type=template&id=b20e981e"
import script from "./RadioGroupWithValidation.vue?vue&type=script&lang=js"
export * from "./RadioGroupWithValidation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports